/// <amd-module name="Wit/WorkItemGitLinks/Components/PullRequest/PullRequestLinkState" />
import * as React from "react";
import { Icon } from "VSSUI/Icon";
import { GitPullRequest, PullRequestStatus } from "VC/Common/Contracts/Git";
import { ILinkDisplayData } from "Wit/WorkItemLinksRegistration/Contracts";
import { DefaultLinkTypeState } from "Wit/WorkItemLinksRegistration/Components";

const classAndIconByStatus = new Map<PullRequestStatus, { className: string; iconName: string }>([
    [PullRequestStatus.Active, { className: "info-text", iconName: "Clock" }],
    [PullRequestStatus.Abandoned, { className: "warning-text", iconName: "StatusErrorFull" }],
    [PullRequestStatus.Completed, { className: "success-text", iconName: "CompletedSolid" }]
]);

export function PullRequestLinkState({ link }: { link: ILinkDisplayData }) {
    const pullRequest = link.additionalData?.pullRequest as GitPullRequest | undefined;
    if (!pullRequest) {
        return <DefaultLinkTypeState link={link} />;
    }

    const { className, iconName } = classAndIconByStatus.get(pullRequest.status) ?? { className: undefined, iconName: undefined };

    return (
        <div className={`inline-flex-row pr-link-status ${className ?? ""}`}>
            <Icon className="icon-margin" iconName={iconName} />
            {link.state}
        </div>
    );
}
